import React from 'react';
import Footer from "./modules/views/Footer";
import AppAppBar from "./modules/views/AppAppBar";
import ThreeDemo from "./modules/views/ThreeDemo";

function ThreeDemoPage() {
  return (
    <React.Fragment>
      <AppAppBar />
      <ThreeDemo />
      <Footer />
    </React.Fragment>
  );
}

export default ThreeDemoPage;
